import { Button, ModalBody, Modal, ModalHeader } from "reactstrap";
import "../../components/layout/Leads/Leads.scss";
import ModalCloseIcon from "../../images/modal-close.svg";
import checkIcon from "../../images/checkGreen.png";
import ArchiveModal from "./ArchiveModal";
interface IProps {
  confirmCloseHandle: (closeTag: boolean) => void;
  confirmCloseModel: boolean;
  confirmText?: string;
  className?: string;
  headerText?: string;
  modalToggle?: () => void;
  getText?: any;
  menuOptions?:any;
  selectedClient?:any;
}

const MovePopUp = (props: IProps) => {
  // console.log(props.confirmText());
  const closeBtn = (
    <button
      className="close"
      onClick={() => props.confirmCloseHandle(false)}
      type="button"
    >
      <img src={ModalCloseIcon} alt="ModalCloseIcon" />
    </button>
  );
  return (
    
  <>
  {props?.menuOptions?.type === "Archive" ? 
   <>
    <ArchiveModal  className="confirmLeadCreated moveContactModal"
       confirmCloseHandle={props.confirmCloseHandle}
       confirmCloseModel={props.confirmCloseModel}
       getText={props.getText}
       selectedClient={props?.selectedClient}
      //  headerText={"Reason For Archive"}
       />
   </>
  
  :

     <Modal
     isOpen={props.confirmCloseModel}
     className={`ToasterPopUp ${props.className}`}
     toggle={props.modalToggle}
   >
     {props.headerText && (
       <ModalHeader close={closeBtn}>
         <img src={checkIcon} alt="check-icon" className="checkGreen" />
         {props.headerText}
       </ModalHeader>
     )}
     <ModalBody>
       <div className="options">
         <h4>{props.getText()}</h4>
         <Button
           className="yes"
           onClick={() => props.confirmCloseHandle(true)}
         >
           Yes
         </Button>
         <Button
           className="no"
           onClick={() => props.confirmCloseHandle(false)}
         >
           No
         </Button>
       </div>
     </ModalBody>
   </Modal>
  }
  </> 
  );
};

export default MovePopUp;
